module.exports = __webpack_public_path__ + "img/180.50df631f.jpg";